import { render, staticRenderFns } from "./OverviewReportDashboard.vue?vue&type=template&id=584dfbda&scoped=true&"
import script from "./OverviewReportDashboard.vue?vue&type=script&lang=js&"
export * from "./OverviewReportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584dfbda",
  null
  
)

export default component.exports